import React from "react";
import { useTranslation } from "@helpers/translate";
import "./SecurityCard.sass";

const StatItem = ({
  value,
  label,
  className = "",
}) => (
  <div
    className={`security-card__stat-item ${className}`.trim()}
  >
    <span className="security-card__stat-value">
      {value}
    </span>

    <span className="security-card__stat-label">
      {label}
    </span>
  </div>
);

const SecurityCard = ({
  shieldAnchorRef,
  contentRef,
}) => {
  const { __ } = useTranslation();

  return (
    <section className="security-card">
      <div
        className="security-card__content-fade-wrapper"
        ref={contentRef}
      >
        <div className="security-card__container">
          <h2 className="security-card__title">
            {__("main.whatWeOffer.security1")}
          </h2>

          <h2 className="security-card__title">
            {__("main.whatWeOffer.security2")}
          </h2>

          <div className="security-card__stats-desktop">
            <div className="security-card__stats-left">
              <StatItem
                value="$0"
                label={__(
                  "main.whatWeOffer.breachLosses",
                )}
              />

              <StatItem
                value="99.9%"
                label={__(
                  "main.whatWeOffer.systemUptime",
                )}
              />
            </div>

            <div className="security-card__image-wrapper">
              <div
                className="security-card__image-space"
                aria-hidden="true"
              />
            </div>

            <div className="security-card__stats-right">
              <StatItem
                value="256-bit"
                label={__(
                  "main.whatWeOffer.dataEncryption",
                )}
              />

              <StatItem
                value="Tier-1"
                label={__(
                  "main.whatWeOffer.custodyPartners",
                )}
              />
            </div>
          </div>

          <div className="security-card__stats-mobile">
            <StatItem
              value="$0"
              label={__(
                "main.whatWeOffer.breachLosses",
              )}
              className="security-card__stat-item--start"
            />

            <StatItem
              value="256-bit"
              label={__(
                "main.whatWeOffer.dataEncryption",
              )}
              className="security-card__stat-item--end"
            />

            <StatItem
              value="99.9%"
              label={__(
                "main.whatWeOffer.systemUptime",
              )}
              className="security-card__stat-item--start"
            />

            <StatItem
              value="Tier-1"
              label={__(
                "main.whatWeOffer.custodyPartners",
              )}
              className="security-card__stat-item--end"
            />

            <div className="security-card__image-wrapper security-card__image-wrapper--span-2">
              <div
                className="security-card__image-space"
                aria-hidden="true"
              />
            </div>
          </div>

          <p className="security-card__description security-card__description--desktop">
            {__(
              "main.whatWeOffer.securityDescFull",
            )}
          </p>

          <p className="security-card__description security-card__description--mobile">
            {__(
              "main.whatWeOffer.securityDesc",
            )}
          </p>
        </div>
      </div>

      <div className="security-card__shield-layer">
        <div
          ref={shieldAnchorRef}
          className="security-card__shield-anchor"
          aria-hidden="true"
        />
      </div>
    </section>
  );
};

export default SecurityCard;
